// extracted by mini-css-extract-plugin
module.exports = {"App":"Ingredients_App__3OIfV","IngredientContainer":"Ingredients_IngredientContainer__3VhKn"};